import { getAccountSettings } from "./accountSettings"

/* @flow weak */

export const authenticAccountsMap = {
  _host: null,
  setHostName: host => {
    if (host) {
      authenticAccountsMap._host = host
    }
  },
  getHostName: () => authenticAccountsMap._host,
  getAccounts: () => JSON.parse(process.env.AUTHENTIC_ACCOUNTS_MAP)
}

export function isomorphicVars(host) {
  if (typeof window === "undefined") {
    authenticAccountsMap.setHostName(host)
    const hostName = host || authenticAccountsMap.getHostName()
    const authenticAccountId = authenticAccountsMap
      .getAccounts()
      .find(item => item.host === hostName)
    const protocol =
      process.env.NODE_ENV === "production" ? "https://" : "http://"
    const publicUrl = protocol + hostName

    let favicon

    const accountSettings = getAccountSettings(authenticAccountId.account_id)

    if (accountSettings) {
      favicon = accountSettings.favicon
    }

    // Running on server.
    return {
      // Modify the code below to set the variables >>>
      version: process.env.npm_package_version,
      public_url: publicUrl,
      admin_url: process.env.ADMIN_URL,
      raygun_api_key: process.env.RAYGUN_API_KEY,
      api_endpoint: process.env.API_ENDPOINT,
      auth_endpoint: process.env.AUTH_ENDPOINT,
      fb_id: process.env.FB_ID,
      authentic_account_id: authenticAccountId && authenticAccountId.account_id,
      accountSettings: accountSettings,
      faviconUrl: favicon && favicon.url
      // <<< Modify the code above to set the variables
    }
  } else return window.isomorphicVars
}



// WEBPACK FOOTER //
// ./webapp/scripts/isomorphicVars.js